import { sortBy } from 'lodash';
import { useMemo } from 'react';
import { API } from '@shared/types/api';
import { CardTemplate } from '../types';

export function useCardTemplates(
  cardDefinition: API.CardDefinitionFragment | undefined,
): CardTemplate[] | undefined {
  return useMemo(() => {
    if (!cardDefinition) {
      return undefined;
    }
    const cardTemplates = cardDefinition?.templates ?? [];
    const templates = cardTemplates.map(t => t.template as CardTemplate);
    return sortBy(templates, t => ('default' in t ? -Number(t.default) : 0));
  }, [cardDefinition]);
}
